<template>
  <v-container style="margin: 0px; padding: 0px; max-width:100%">
    <v-toolbar color="indigo" dark dense>
      <v-toolbar-title>Policy Documents</v-toolbar-title>
    </v-toolbar>
    <v-layout>
      <Iterator :items="docs"  :displayItem="displayComponent" height=200 short=true  
      v-on:itemtocart="addToCart()"/>
    </v-layout>
  </v-container>
</template>

<script>
import axios from "axios"
import axiosInstances from "@/../../coreui/server/axiosInstances"
import { sync } from "vuex-pathify"
import DisplayItem from './DisplayItem'
import Iterator from '@/../../coreui/components/Iterator'
export default {
  name: 'Policy_AllDocs',
  components: {
    DisplayItem,
    Iterator
  },
  data() {
    return {
      displayComponent: DisplayItem,
      windowSize: {
        x: 0,
        y: 0,
      },
      bottom: false,
      products: [],
      docs: [],
      cartItems: [],
      inventoryItems: [],
      rowsPerPageItems: [4, 8, 12, 16, 20],
      page: { rowsPerPage: 8 },
      busy: false,
      images: null,
    };
  },
  computed: {
    numItems () {
      return this.cartItems.length
    },
    widgetHeight() {
      let w = (this.windowSize.y - 350) / this.rowsPerPage;
      return w;
    },
    user: sync('login/loggedinUser'),
    numberOfPages() {
      return Math.ceil(this.products.length / this.page.rowsPerPage);
    },
    rowsPerPage() {
      let x = Math.ceil(this.page.rowsPerPage / this.itemsPerRow);
      // this.page.rowsPerPage = x
      return x;
    },
    itemsPerRow() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return 1;
        case "sm":
          return 1;
        case "md":
          return 2;
        case "lg":
          return 2;
        case "xl":
          return 2;
      }
    },
  },
  watch: {
    page(val) {
      // console.log("page changed: ", val);
    },
  },
  methods: {
    removeItem (index) {
      this.cartItems.splice(index, 1)
    },
    cart() {
      this.cartclosed = !this.cartclosed;
    },
    addToCart(item) {
      console.log('Item: ', item)
      
    },
    onResize() {
      this.windowSize = { x: window.innerWidth, y: window.innerHeight };
    },
    async getProducts() {
      // get items from the server
      let res = await axiosInstances.apiServer.get("/dt/v1/fac_products")
      this.products = res.data == null ? [] : res.data
      // for (const i of this.products) {
      // }
      await this.getImages();
    },
    async getDocs() {
      // get items from the server
      let res = await axiosInstances.apiServer.get("/dt/v1/docs")
      console.log(res)
      this.docs = res.data
      return
      await this.getProducts()
      this.inventory = res.data == null ? [] : res.data
      for (const i of this.inventory) {
        var prod = this.products.find(j => j._id == i.name)
        let n = prod == undefined ? 'No Product Name' : prod.name
        let price = prod == undefined || prod.price == undefined ? 'unlisted' : prod.price
        this.inventoryItems.push({
          _id: i._id,
          name: n,
          prod_id: i.name,
          available: i.aqty.qty + ' ' + i.aqty.unit,
          price: price,
          unit: i.aqty.unit == 'units' ? 'each' : i.aqty.qty,
          lots: i.lots.filter(i => i.aqty.qty != 0).length
        })
      }
      // await this.getImages();
    },
    nextPage() {
      if (this.page + 1 <= this.numberOfPages) this.page += 1;
    },
    formerPage() {
      if (this.page - 1 >= 1) this.page -= 1;
    },
    async getImages() {
      var tempImages = {};
      var self = this;
      // for (const i of this.inventoryItems) 
      await Promise.all(this.inventoryItems.map(async (i) => 
      {
        var url =
          "/getfiles/" +
          self.user.org +
          "/" +
          i.prod_id +
          ".png?subdir=fac_products";
        try {
          let img = await axiosInstances.apiServer.get(url, {
            responseType: "arraybuffer",
          });

          var bytes = new Uint8Array(img.data);
          var binary = bytes.reduce(
            (data, b) => (data += String.fromCharCode(b)),
            ""
          );
          var imgsrc = btoa(binary);
          if (imgsrc != null && imgsrc != "") {
            console.log(i)
            tempImages[i._id] = "data:image/png;base64," + imgsrc;
          }
        } catch {}
        console.log(tempImages)
      }))
      console.log('temp images: ', tempImages)
      self.images = tempImages
      console.log('images: ', self.images , tempImages)
    },
  },

  mounted() {
    console.log('getting docs')
    this.getDocs();
    this.onResize();
    let self = this
    // this.$root.$on('itemtocart', function(obj) {
    //   console.log(obj.item)
    //   self.addToCart(obj.item)
    // })
  },
};
</script>


<style scoped>
.v-tooltip__content.menuable__content__active {
  opacity: 1 !important;
}
.card-outter {
  position: relative;
  padding-bottom: 50px;
}
.card-actions {
  position: absolute;
  bottom: 0;
}
.item {
  border: 2px solid gray;
  border-radius: 5px;
  margin: 5px;
  padding: 5px;
}
.addbutton {
  margin-left: -5px;
  padding: 5px;
  border: 1px;
  background: green;
  transition: all 0.1s ease-out;
  border-radius: 5px;
  color: white;
}
.mh-100 {
  min-height: 100vh;
  max-height: 100vh;
  height: 100vh;
}

.overflow-hidden {
  overflow: hidden;
}
#empty-image {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>